import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>PedalScot</h3>
          <p>Deine Cycling-App für Schottland</p>
        </div>

        <div className="footer-section">
          <h4>Rechtliches</h4>
          <ul>
            <li><Link to="/impressum">Impressum</Link></li>
            <li><Link to="/agb">AGB</Link></li>
            <li><Link to="/datenschutz">Datenschutz</Link></li>
            <li><Link to="/cookies">Cookie-Richtlinie</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Kontakt</h4>
          <ul>
            <li><a href="mailto:info@pedalscot.com">info@pedalscot.com</a></li>
            <li><a href="mailto:support@pedalscot.com">Support</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Social Media</h4>
          <ul>
            <li><a href="#" target="_blank" rel="noopener noreferrer">Facebook</a></li>
            <li><a href="#" target="_blank" rel="noopener noreferrer">Instagram</a></li>
            <li><a href="#" target="_blank" rel="noopener noreferrer">Twitter</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 PedalScot. Alle Rechte vorbehalten.</p>
        <p className="safety-note">
          ⚠️ Radfahren auf eigene Gefahr. Bitte Helm tragen und Verkehrsregeln beachten.
        </p>
      </div>
    </footer>
  );
}
